export default function (state, index) {
    //state.currentSetting = JSON.stringify(state.settings[index]);
    let temp = JSON.stringify(state.settings.find(x=> x.Id == index));
    state.currentSetting = JSON.parse(temp);
}